<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e1102537" style="color: #82a339"><b>SALMON PÂTÉ</b></p>
<p class="ext" id="d7e1103137"><b><i>This combination of fresh and smoked salmon brings elegance to a Sunday brunch buffet, while the microwave and food processor make preparation easy.</i></b></p>
<p class="h4" id="d7e1104437" style="color: #496210"><b>Prep: 10 minutes plus chilling <br/> Cook: 2 minutes</b></p>
<p class="ul" id="d7e1105237">1 lemon</p>
<p class="ul" id="d7e1105537">1 piece salmon fillet (8 ounces), skin removed</p>
<p class="ul" id="d7e1105837">¼ teaspoon salt</p>
<p class="ul" id="d7e1106737">⅛ teaspoon ground black pepper</p>
<p class="ul" id="d7e1107737">2 tablespoons water</p>
<p class="ul" id="d7e1108037">8 ounces smoked salmon</p>
<p class="ul" id="d7e1108337">3 tablespoons butter or margarine, softened</p>
<p class="ul" id="d7e1108637">2 tablespoons reduced-fat cream cheese</p>
<p class="ul" id="d7e1109037">2 tablespoons chopped fresh chives <br/> toast rounds or unsalted crackers</p>
<p class="pub" id="d7e1109837" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> From lemon, grate 1 teaspoon peel. Cut lemon in half. From 1 lemon half, squeeze 1 tablespoon juice; cut other lemon half into 3 slices. Set peel and juice aside.</p>
<p class="pub" id="d7e1111137"><span style="color: #c15b49"><b>2.</b></span> Sprinkle salmon fillet with salt and pepper to season both sides. Place in microwave-safe shallow bowl or glass pie plate. Top salmon with lemon slices and water. Cook, covered, in microwave oven on High 2 minutes. Let stand, covered, 2 minutes longer. Remove salmon from liquid and place in medium bowl; flake with fork and set aside to cool.</p>
<p class="pub" id="d7e1113837"><span style="color: #c15b49"><b>3.</b></span> Meanwhile, in food processor with knife blade attached, pulse smoked salmon, butter, Neufchâtel, and lemon peel and juice just until smooth (do not overprocess). Gently stir smoked salmon mixture and 1 tablespoon chives into flaked salmon in bowl just until combined. Wrap remaining chives in plastic wrap and refrigerate for garnish later. Spoon salmon pâté into serving bowl or crock; cover and refrigerate for at least 2 hours or overnight.</p>
<p class="pub" id="d7e1117137"><span style="color: #c15b49"><b>4.</b></span> To serve, let pâté stand at room temperature 30 minutes or until soft enough to spread. Garnish pâté with remaining chives. Serve with toast rounds or crackers. Makes about 2 cups.</p>
<p class="ntx" id="d7e1119037">Each tablespoon: About 30 calories, 3g protein, 0g carbohydrate, 2g total fat (1g saturated), 0g fiber, 6mg cholesterol, 180mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c24_r1.vue?fa1cb154